import { FC } from 'react';
import BasicSelect from 'further-ui/components/BasicSelect';
import api from 'lib/trpcClient';
import { SortOrder } from 'further-types/utils';

type Props = {
  value?: string;
  onChange: (roleId: string) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  fullWidth?: boolean;
  placeholder?: string;
};

export const AdminUserRoleSelector: FC<Props> = ({
  value,
  onChange,
  disabled,
  error,
  helperText,
  fullWidth = true,
  placeholder,
}) => {
  const { data: availableRoles, isLoading } = api.adminUserRole.list.useQuery({
    page: 1,
    order: SortOrder.Asc,
    orderBy: 'name',
    rowsPerPage: Number.MAX_SAFE_INTEGER,
  });

  const options = availableRoles?.results
    ? availableRoles.results.map((role) => ({
        label: role.name,
        value: role.auth0RoleId,
        description: role.description ?? '-',
      }))
    : [];

  return (
    <BasicSelect
      value={value}
      onChange={onChange}
      options={options}
      disabled={disabled || isLoading}
      error={error}
      helperText={helperText}
      fullWidth={fullWidth}
      placeholder={placeholder}
      noOptionsMessage="No roles available"
    />
  );
};

export default AdminUserRoleSelector;
